import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

export const updatePredicateStorePartOrder = () => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const updatePredicatePartOrder = useStore(store, (s) => s.updatePartOrder);

    return updatePredicatePartOrder;
};
